import { AbstractDownloadableService } from './abstract-downloadable.service';
import { ReservationActivity } from '../models';

/**
 * @class StaffActivityPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<ReservationActivity>}
 */
export class StaffActivityPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/staff-activity';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param params
     * @returns {ReservationActivity}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationActivity(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<ReservationActivity>>}
     */
    get(params = {}) {
        
        const url = this.url({});

        return this.http
            .post(url, params,{
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    exportCsv(params = {}) {

        const url = this.url() + '/export-csv';

        return this.download(url, params, 'Staff Activity Log.csv');
    }

    exportExcel(params = {}) {

        const url = this.url() + '/export-excel';

        return this.download(url, params, 'Staff Activity Log.xls');
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/staff-activity.service.js